import { useState } from 'react'
import { useBetween } from 'use-between'
import { BTGlobal as GlobalBT } from '../../../utils/BTglobal/BTGlobal'
import { contStep3 } from '../form/StepContract3'
import { createContractSchemas } from '../ICreateContract'

const BTCreateContract3 = () => {
  const { btGridRef } = useBetween(GlobalBT)
  const [contractSchemas, setContractSchemas] = useState(createContractSchemas[0])
  const [dataRow3, setDataRow3] = useState<contStep3[]>([])
  const [dataModelo3, setDataModelo3] = useState<any>()
  const [ingByCeco, setIngByCeco] = useState<any>([])

  const addRowStructure3 = (props: any) => {
    let data = {
      cycleWeek: props.dataRow.cycleWeek,
      fatherStructure2: props.dataRow.fatherStructure2,
      mainIngredients: props.dataRow.mainIngredients,
      recipe: props.dataRow.recipe,
      id: props.dataRow.id,
    }
    setDataModelo3(data)
  }

  const updateRow3 = (items: any) => {
    let dRow = dataRow3.slice()
    setDataRow3([])
    let newRow = dRow.filter((item) => {
      if (item.id === items.id) {
        item.cycleWeek = items.cycleWeek
        item.data = items
        item.fatherStructure2 = items.fatherStructure2[0].text
        item.mainIngredients = items.mainIngredients[0].text
        item.recipe = items.recipe[0].text
      }
      return item
    })
    setDataRow3(newRow)
    if (btGridRef !== undefined) btGridRef.current.api.refreshServerSideStore({ purge: true })
  }

  const deleteRow3 = (props: any) => {
    //fatherStructure2-idMainIngredients-cycleWeek-idDiaReceta
    let rows = dataRow3.slice()
    let newRow = rows.filter((item) => {
      return item.fatherStructure2 !== props.dataRow.fatherStructure2
        || item.idMainIngredients !== props.dataRow.idMainIngredients
        || item.cycleWeek !== props.dataRow.cycleWeek
        || item.idDiaReceta.toString() !== props.dataRow.idDiaReceta.toString()
      //return item.idDelete !== props.dataRow.idDelete
    })
    setDataRow3(newRow)
  }

  return {
    contractSchemas,
    setContractSchemas,
    dataRow3,
    setDataRow3,
    updateRow3,
    deleteRow3,
    dataModelo3,
    setDataModelo3,
    addRowStructure3,
    ingByCeco,
    setIngByCeco,
  }
}
export { BTCreateContract3 }
